const pad2 = (number: number) => String(number).padStart(2, '0');

const toDate = (value?: string | Date | null): Date | null => {
  if (!value) return null;
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

export const addHours = (
  value?: string | Date | null,
  hours: number = 0
): Date | null => {
  const date = toDate(value);
  if (!date) return null;
  const result = new Date(date.getTime() + hours * 60 * 60 * 1000);
  return result;
};

export const formatDate = (value?: string | Date | null): string => {
  const date = toDate(value);
  if (!date) return '—';
  return `${date.getFullYear()}.${pad2(date.getMonth() + 1)}.${pad2(
    date.getDate()
  )}`;
};

export const formatTime = (value?: string | Date | null): string => {
  const date = toDate(value);
  if (!date) return '';
  return `${pad2(date.getHours())}:${pad2(date.getMinutes())}`;
};

export const formatDateTime = (value?: string | Date | null): string => {
  const date = toDate(value);
  if (!date) return '';
  return `${date.getFullYear()}/${pad2(date.getMonth() + 1)}/${pad2(
    date.getDate()
  )} ${pad2(date.getHours())}:${pad2(date.getMinutes())}`;
};

export const formatCountdownTo = (value?: string | Date | null): string => {
  const target = toDate(value);
  if (!target) return '';

  const now = new Date();
  let diffMs = target.getTime() - now.getTime();

  if (diffMs <= 0) {
    return '00:00:00';
  }

  const totalSeconds = Math.floor(diffMs / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  return `${hours}:${pad2(minutes)}:${pad2(seconds)}`;
};
